module.exports = __webpack_public_path__ + "img/ts4.b357cf43.png";